import { assocPath, mapObjIndexed, propOr } from 'ramda';
import { getItem, setItem } from '../utils/storage';

const flagDefaults = {
    services: false,
    canvas: false,
    'operator-v2': false,
};

export const flags = () => {
    const userFlags = getItem(window.localStorage, 'flags') || {};

    // Merge the user's flag statuses with the defaults
    // This will prune any user flags that are not included in flagDefaults
    const mergedFlags = mapObjIndexed(
        (defaultEnabled, key) => propOr(defaultEnabled, key, userFlags),
        flagDefaults,
    );

    // Save pruned flags back to browser storage
    setItem(window.localStorage, 'flags', mergedFlags);

    return mergedFlags;
};

export const getFlag = flagName => flags()[flagName];

export const setFlag = (flagName, value) => {
    const currentFlags = flags();

    if (Object.prototype.hasOwnProperty.call(currentFlags, flagName)) {
        currentFlags[flagName] = value;
    }

    setItem(window.localStorage, 'flags', currentFlags);

    console.warn('Please refresh the browser window to ensure correct functionality of flagged features');

    return currentFlags;
};

export const enable = flagName => setFlag(flagName, true);

export const disable = flagName => setFlag(flagName, false);

export const status = () => ({ ...flags() });

// Expose these functions to enable switching features on/off at runtime
window.boomi = assocPath(
    ['flow', 'admin', 'flag'],
    {
        enable,
        disable,
        status,
    },
    window.boomi,
);
